module.exports = __webpack_public_path__ + "img/icon-gynecology.78252263.png";